module.exports = __webpack_public_path__ + "img/icon-web-home-02.95e15440.jpg";